'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { addFeedbackReply } from '@/lib/actions';

interface Props {
  feedbackId: string;
}

export default function FeedbackReplyForm({ feedbackId }: Props) {
  const router = useRouter();
  const [content, setContent] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;
    setSubmitting(true);
    const fd = new FormData();
    fd.set('content', content);
    await addFeedbackReply(feedbackId, fd);
    setContent('');
    setSubmitting(false);
    router.refresh();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <textarea
        value={content}
        onChange={e => setContent(e.target.value)}
        placeholder="Write a reply..."
        rows={3}
        className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-sm text-slate-200 placeholder-slate-500 focus:outline-none focus:border-purple-500/50 resize-y"
      />
      <button
        type="submit"
        disabled={submitting || !content.trim()}
        className="px-4 py-2 bg-purple-600 hover:bg-purple-500 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg text-sm font-bold transition-colors"
      >
        {submitting ? 'Sending...' : 'Reply'}
      </button>
    </form>
  );
}
